import { Component } from '@angular/core';

import { BaseFormComponent } from '../base-form.component';

@Component({
  moduleId: module.id,
  selector: 'coverage-details',
  templateUrl: './coverage-details.component.html',
})
export class CoverageDetailsComponent extends BaseFormComponent {
  updateFromModel(): void {}
}
